<div class="modal-header">
  <h4 class="modal-title">Eye Examination</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body" [formGroup]="examinationForm">
    <div class="container mt-4">
      <h3>Examination</h3>
      <div class="row">
        <!-- VR Column -->
        <div class="col-md-6">
          <div class="d-flex justify-content-center align-items-center mb-2" style="height: 40px;">
            <label for="vr" class="mb-0 fw-bold">VR</label>
          </div>
          <!-- <input type="text" id="vr" class="form-control" formControlName="vr" />
                  <label class="mt-2">VR Glasses</label> -->
          <div class="col-xl-12">
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_glasses_id" (keypress)="keyPressAlphaNumeric($event)">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of glassesList">{{g.name}}</option>
              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_lid_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of lidList">{{g.name}}</option>
              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_conjuctiva_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of conjunctiveList">{{g.name}}</option>

              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_cornea_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of corneaList">{{g.name}}</option>

              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_ac_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of acList">{{g.name}}</option>

              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_pupil_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of pupilList">{{g.name}}</option>

              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <select class="form-control form-control-sm" formControlName="vr_lens_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of lensList">{{g.name}}</option>

              </select>
            </div>
            <div class="col-xl-12 mt-2">
              <input type="text" class="form-control form-control-sm" formControlName="vr_vitreous" >
            </div>
            <div class="col-xl-12 mt-2">
              <input type="text" class="form-control form-control-sm" formControlName="vr_fundus">
            </div>
            <div class="col-xl-12 mt-2">
              <input type="text" class="form-control form-control-sm" formControlName="vr_iop" (keypress)="keyPressNumbers($event)">
            </div>
            <div class="col-xl-12 mt-2">
              <input type="text" class="form-control form-control-sm" formControlName="vr_retina">
            </div>
          </div>
        </div>

        <!-- VL Column -->
        <div class="col-md-6">
          <!-- Label and Input Row -->
          <div class="d-flex justify-content-center align-items-center mb-2" style="height: 40px;">
            <label for="vl" class="mb-0 fw-bold">VL</label>
          </div>
          <!-- <input type="text" id="vr" class="form-control" formControlName="vl" />
                    <label class="mt-2">VL Glasses</label> -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>Glasses</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_glasses_id" (keypress)="keyPressAlphaNumeric($event)">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of glassesList">{{g.name}}</option>
              </select>
            </div>
          </div>

          <!-- LID -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>LID</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_lid_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of lidList">{{g.name}}</option>
              </select>
            </div>
          </div>

          <!-- CONJUNCTIVA -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>CONJUNCTIVA</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_conjuctiva_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of conjunctiveList">{{g.name}}</option>

              </select>
            </div>
          </div>

          <!-- CORNEA -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>CORNEA</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_cornea_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of corneaList">{{g.name}}</option>

              </select>
            </div>
          </div>

          <!-- A/C -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>A/C</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_ac_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of acList">{{g.name}}</option>

              </select>
            </div>
          </div>

          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>PUPIL</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_pupil_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of pupilList">{{g.name}}</option>

              </select>
            </div>
          </div>
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>LENS</label>
            </div>
            <div class="col-md-8">
              <select class="form-control form-control-sm" formControlName="vl_lens_id">
                <option value=null>Select</option>
                <option [value]="g.id" *ngFor="let g of lensList">{{g.name}}</option>

              </select>
            </div>
          </div>

          <!-- Extra Inputs -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>VITREOUS</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-sm" formControlName="vl_vitreous">

            </div>
          </div>

          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>FUNDUS</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-sm" formControlName="vl_fundus">
            </div>
          </div>

          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>IOP</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-sm" formControlName="vl_iop" (keypress)="keyPressNumbers($event)">
            </div>
          </div>

          <div class="row align-items-center mt-2">
            <div class="col-md-4 text-end">
              <label>RETINA</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-sm" formControlName="vl_retina">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" id="saveButton" class="btn btn-primary btn-sm"
    (click)="onSave()">Save</button>

  <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
    (click)="activeModal.close('Close click')">Close</button>
</div>